import { progressPct } from "@/lib/progress";
import { computeWbsIds } from "@/lib/wbsIds";
import { HEALTH_COLORS, taskHealth } from "@/components/PhaseFlowView";

const healthOf = (t, today) => {
  if (t.health) return t.health === "red" ? "red" : t.health === "yellow" ? "yellow" : "green";
  return taskHealth(t, today);
};

const fmtD = (d) => (d ? new Date(d + "T00:00:00").toLocaleDateString(undefined, { month: "short", day: "numeric" }) : "TBD");

export const ReportFlowStrip = ({ phases = [], tasks = [], phaseColors = {}, progressStyle }) => {
  const today = new Date().toISOString().slice(0, 10);
  const wbsIds = computeWbsIds(tasks, phases);
  const model = phases.map((ph, pi) => {
    const items = tasks.filter((t) => t.phase === ph && !t.is_summary);
    const work = items.filter((t) => !t.is_milestone).sort((a, b) => (a.end_date || "9999").localeCompare(b.end_date || "9999"));
    const milestones = items.filter((t) => t.is_milestone).sort((a, b) => (a.end_date || "9999").localeCompare(b.end_date || "9999"));
    const output = milestones[milestones.length - 1] || null;
    const scored = items;
    const pct = progressPct(scored, progressStyle);
    return { ph, pi, work, output, pct };
  }).filter((m) => m.work.length || m.output);
  if (!model.length) return <p className="text-sm text-muted-foreground italic">No plan phases yet.</p>;
  return (
    <div className="space-y-3" data-testid="report-flow-strip">
      <div className="flex items-center gap-3 flex-wrap">
        <span className="text-[10px] font-bold uppercase tracking-wide text-muted-foreground">Task colors:</span>
        {[["green", "On track / done"], ["yellow", "Behind / at risk"], ["red", "Overdue / jeopardy"]].map(([k, label]) => (
          <span key={k} className="inline-flex items-center gap-1.5 text-[11px] font-semibold text-foreground/70">
            <span className="h-2 w-2 rounded-full shrink-0" style={{ background: HEALTH_COLORS[k] }} /> {label}
          </span>
        ))}
      </div>
      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-3">
        {model.map((m) => {
          const color = phaseColors[m.ph] || "#1c6cb5";
          const shown = m.work.slice(0, 6);
          return (
            <div key={m.ph} className="rounded-lg border border-border bg-card overflow-hidden" style={{ borderTop: `3px solid ${color}` }} data-testid={`report-flow-phase-${m.ph}`}>
              <div className="flex items-center justify-between gap-2 px-3 py-2 border-b border-border/60">
                <p className="text-xs font-bold truncate">Phase {m.pi + 1} · {m.ph}</p>
                <span className="text-xs font-extrabold tabular-nums shrink-0" style={{ color }}>{m.pct}%</span>
              </div>
              <div className="px-3 py-2 space-y-1">
                {shown.map((t) => {
                  const hc = HEALTH_COLORS[healthOf(t, today)];
                  return (
                    <div key={t.id} className="flex items-center gap-1.5 text-[11px] leading-tight">
                      <span className="h-2 w-2 rounded-full shrink-0" style={{ background: hc }} />
                      <span className="font-mono font-bold opacity-60 shrink-0">{wbsIds[t.id]}</span>
                      <span className="truncate flex-1">{t.title}</span>
                      <span className="tabular-nums font-semibold opacity-70 shrink-0">{t.percent_complete || 0}%</span>
                    </div>
                  );
                })}
                {m.work.length > 6 && <p className="text-[10px] text-muted-foreground pl-3.5">+{m.work.length - 6} more task{m.work.length - 6 === 1 ? "" : "s"}</p>}
                {m.output && (
                  <p className="flex items-center gap-1.5 text-[11px] font-semibold pt-1 border-t border-border/50 mt-1.5">
                    <span style={{ color }}>◆</span>
                    <span className="truncate flex-1">Output: {m.output.title}</span>
                    <span className="text-muted-foreground shrink-0">{fmtD(m.output.end_date)}</span>
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ReportFlowStrip;
